import React from 'react';

const Badge = ({ children, variant = 'default', className = '' }) => {
    const variants = {
        default: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
        primary: 'bg-[#00152E]/10 text-[#1a3884] dark:bg-[#1a3884]/20 dark:text-blue-300',
        success: 'bg-green-100 text-green-800 dark:bg-green-950/40 dark:text-green-400',
        warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-950/40 dark:text-yellow-400',
        danger: 'bg-red-100 text-red-800 dark:bg-red-950/40 dark:text-red-400',
        info: 'bg-[#00152E]/10 text-[#1a3884] dark:bg-[#1a3884]/20 dark:text-blue-300',
        indigo: 'bg-[#00152E]/10 text-[#1a3884] dark:bg-[#1a3884]/20 dark:text-blue-300',
        purple: 'bg-purple-100 text-purple-800 dark:bg-purple-950/40 dark:text-purple-400',
        teal: 'bg-teal-100 text-teal-800 dark:bg-teal-950/40 dark:text-teal-400',
    };

    return (
        <span
            className={`inline-flex items-center whitespace-nowrap px-2.5 py-0.5 rounded-full text-xs font-medium ${variants[variant]} ${className}`}
        >
            {children}
        </span>
    );
};

export default Badge;
